import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      num: '01',
      title: 'Executive Communications Coaching',
      desc: 'One-on-one coaching for founders and CXOs who need their leadership voice to match the scale of their ambition. We work on presence, narrative, and the ability to make conviction visible in any room.'
    },
    {
      num: '02',
      title: 'Narrative & Positioning',
      desc: 'For leaders navigating high-stakes moments — a fundraise, a launch, a pivot, a leadership transition. We help you build the story, sharpen the message, and ensure it lands with the audiences that matter most.'
    },
    {
      num: '03',
      title: 'Reputation Strategy & Crisis Communications',
      desc: 'When perception is under threat, speed and precision are everything. We work with leaders to assess, respond, and reshape — protecting what they\'ve built while maintaining trust with the people who matter.'
    },
    {
      num: '04',
      title: 'Brand Storytelling',
      desc: 'For category-defining companies that need a narrative as strong as their product. We help build the communications architecture that turns a compelling company into a compelling story.'
    }
  ];

  return (
    <section className="services" id="services">
      <div className="services-intro">
        <div>
          <p className="section-label">What we do</p>
          <h2 className="section-heading">Four ways<br />we can work<br />together.</h2>
        </div>
        <p className="services-subhead">Every engagement is built around your specific moment — the narrative you need to own, the perception you need to shift, or the presence you need to build. No templates. No generic frameworks.</p>
      </div>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <span className="service-num">{service.num}</span>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-desc">{service.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
